import { Button, Tabs, message } from 'antd';
import React, { Component } from 'react'
import InvInfor from './components/InvInfor';
import InvServiceContent from './components/InvServiceContent';
import SideNav from '../SideNav';
import $ from "../../../common/AjaxRequest";
import API_URL from '../../../common/url';
import "./index.less";
import ClientParams from './components/ClientParams';
import KeyAnalysis from './components/KeyAnalysis';
import FTEQuoteRule from './components/FTEQuoteRule';
import { saveEvaluateParams } from '../../../actions/clinicalEvaluationActions';
import { connect } from "react-redux";

const TabPane = Tabs.TabPane;

class FTEAssess extends Component {

    state = {
        params: {},
        type: "view",
        loading: false,
        activeKey: 'InvInfor',
        fileList: [],
        evaluateRecordCustomer:{},
        evaluateRecordView: {},
        evaluateServeConfigList: [], //项目服务内容
        record: {},
    };

    componentDidMount() {
        this.loadData();
        this.loadRecordData();
    }

    loadRecordData = (evaluateRecordId) => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryEvaluateRecords,
            data: {
                evaluateRecordId,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas } = res;
                this.setState({
                    record: datas[0] || {},
                });
            }
        };
        $.sendRequest(options);
    }

    loadData = () => {
        const { evaluateRecordId } = this.props.match.params;
        this.setState({ loading: true });
        const options = {
            method: "POST",
            url: API_URL.evaluate.queryEvaluateServeCustomer,
            data: {
                evaluateRecordId,
            },
            dataType: "json",
            doneResult: (res) => {
                const {
                    data: {
                        evaluateServeConfigList,
                        evaluateRecordCustomer,
                        evaluateRecordView,
                    }
                } = res;
                this.setState(
                    {
                        loading: false,
                        params: {
                            ...evaluateRecordView,
                            ...evaluateRecordCustomer,
                            sponsorCompanyName: evaluateRecordView.sponsorName,
                        },
                        evaluateServeConfigList,
                    },
                    this.queryEnclosureFileList
                );
            },
        }
        $.sendRequest(options);
    }

    queryEnclosureFileList = () => {
        const { params: { evaluateRecordCustomerId } } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryEnclosureFileList,
            data: { 
                relateId: evaluateRecordCustomerId,
                uploadType: 'EVALUATE_RECORD_CUSTOMER_FILE'
            },
            dataType: 'json',
            doneResult: res => {
                const fileList = res.datas || [];
                fileList.forEach(item => {
                    item.response = { fileMetaId: item.fileMateId };
                    item.uid = item.fileMateId;
                });
                this.setState({
                    fileList: [ ...fileList ],
                });
            }
        };
        $.sendRequest(options);
    }

    handelTabChange = (value) => {
        this.setState({
            activeKey: value
        })
    }

    calculateVisitFee = () => {
        const { 
            params:{
                evaluateRecordId,
            },
        } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.evaluate.calculateFteFee,
            data: { 
                evaluateRecordId,
            },
            dataType: 'json',
            doneResult: res => {
                const { success } = res;
                message.success(success)
            }
        };
        $.sendRequest(options);
    }

    leave = () => {
        this.props.saveEvaluateParams({ feedBack: true });
        window.history.go(-1);
    }

    render() {
        const { 
                type, 
                params, 
                activeKey, 
                params:{
                    evaluateCode,
                    evaluateRecordId,
                },
                fileList,
                evaluateServeConfigList,
                record,
            } = this.state;
            const { curRole } = sessionStorage;
            const { pmlAuth, pmAuth } = record;
        const TabsConfig = [
            {
                title: '项目基本信息',
                key: 'InvInfor',
                Dom: <InvInfor 
                        key='InvInfor'
                        type={type} 
                        params={params}
                    />
            },
            {
                title: '项目服务内容',
                key: 'InvServiceContent',
                Dom: <InvServiceContent 
                        key='InvServiceContent'
                        type={type}
                        params={params} 
                        Config={evaluateServeConfigList}
                    />
            },
            {
                title: '客户项目参数',
                key: 'ClientParams',
                Dom: <ClientParams 
                        key='ClientParams'
                        type={type}
                        fileList={fileList}
                        record={record}
                        params={params}
                    />
            },
            {
                title: 'FTE报价规划',
                key: 'FTEQuoteRule',
                Dom: <FTEQuoteRule 
                        key='FTEQuoteRule'
                        evaluateRecordId={evaluateRecordId}
                        record={record}
                        pageName='edit'
                    />
            },
            {
                title: '重点难点分析&其他备注说明',
                key: 'KeyAnalysis',
                Dom: <KeyAnalysis
                        key='KeyAnalysis'
                        type={type}
                        evaluateRecordId={evaluateRecordId}
                        quotationType={'FTE_QUOTATION'}
                    />
            },
        ];
        return (
            <div className="content visitAssess">
                <SideNav selectKey='record' />
                <div className="main">
                <div style={{ overflow: 'hidden' }}>
                    <div style={{ float: 'left', margin: '10px', marginTop: 0 }}>
                        <i
                            className="icon iconfont"
                            style={{ marginRight: 4, fontSize: '20px', color: '#1296DB'}}
                        >&#xe65b;</i>
                        {`临床评估单号：${evaluateCode}`}
                    </div>
                    <Button 
                            type="primary"
                            onClick={() => this.calculateVisitFee()}>评估计算</Button>
                    <div 
                        style={{ 
                            float: 'right', 
                            marginRight: 10, 
                            color: '#1296DB', 
                            cursor: 'pointer',
                        }} 
                        onClick={() => this.leave()}>
                        <i
                            className="icon iconfont"
                            style={{ marginRight: 4, fontSize: '20px' }}
                        >&#xe63d;</i>
                        返回
                    </div>
                </div>
                <Tabs onChange={this.handelTabChange} type="card" activeKey={activeKey}>
                    {
                        TabsConfig.map(teb => {
                            const { show = true } = teb;
                            if(show) return <TabPane tab={teb.title} key={teb.key}>{teb.Dom}</TabPane>
                        })
                    }
                </Tabs>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        evaluateParams: state.clinicalEvaluationState.evaluateParams,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveEvaluateParams: (params) => dispatch(saveEvaluateParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FTEAssess);



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/FTEAssess.js